import { Box, Typography } from "@material-ui/core";
import React from "react";
import clsx from "clsx";

interface IClusterMarker {
  lat: number;
  lng: number;
  zIndex: number; // **Important** This prop is used by google-maps-react-markers during the rendering of the markers
  pointCount: number;
  clusterId: number;
  forceHoverState?: boolean; // If the cluster is hovered from the list, force the hover state
  onClusterHover?: (clusterId: number) => void;
  onClusterClick: (clusterId: number, lat: number, lng: number) => void;
}
export const ClusterMarker = (props: IClusterMarker) => {
  const {
    lat,
    lng,
    pointCount,
    clusterId,
    forceHoverState,
    onClusterHover,
    onClusterClick,
  } = props;

  const handleClusterHover = () => {
    if (onClusterHover) {
      onClusterHover(clusterId);
    }
  };

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="75px"
      height="75px"
      className="default-cluster"
      style={{
        backgroundColor: "rgba(2, 101, 151, 0.2)",
        borderRadius: "125px",
      }}
      onMouseEnter={handleClusterHover}
      onClick={() => onClusterClick(Number(clusterId), lat, lng)}
    >
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        width="50px"
        height="50px"
        className={clsx("cluster-inner-circle", {
          hover: forceHoverState,
        })}
        style={{
          borderRadius: "100px",
          border: "1px solid #026597",
          boxShadow: "1px 1px 5px rgba(0,0,0,0.3)",
        }}
      >
        <Typography
          style={{
            fontWeight: "600",
          }}
        >
          {pointCount}
        </Typography>
      </Box>
    </Box>
  );
};
